/**
 * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
 */
import React from 'react';

export const getFlexStyleForColumn = (column, customStyle = {}) => {
  const flexGrow = column.props.flexGrow != null ? column.props.flexGrow : 0;
  const flexShrink = column.props.flexShrink != null ? column.props.flexShrink : 1;
  // Use width if present, otherwise fall back to minWidth as basis to keep layout stable
  const basisPx = column.props.width != null ? column.props.width : column.props.minWidth;
  const basis = basisPx != null ? `${basisPx}px` : 'auto';

  const flexValue = `${flexGrow} ${flexShrink} ${basis}`;

  const style = {
    ...customStyle,
    flex: flexValue,
    msFlex: flexValue,
    WebkitFlex: flexValue,
  };

  if (column.props.maxWidth) {
    style.maxWidth = column.props.maxWidth;
  }

  if (column.props.minWidth) {
    style.minWidth = column.props.minWidth;
  }

  return style;
};

export const defaultCellRenderer = ({ cellData }) => {
  if (cellData == null) {
    return '';
  }
  return String(cellData);
};

export const defaultCellDataGetter = ({ dataKey, rowData }) => {
  if (typeof rowData?.get === 'function') {
    return rowData?.get(dataKey);
  }
  return rowData[dataKey];
};

export const defaultHeaderRenderer = params => {
  const { label } = params;
  return (
    <span key="label" title={typeof label === 'string' ? label : null}>
      {label}
    </span>
  );
};

export const defaultHeaderRowRenderer = params => {
  const { className, columns, style, ref } = params;

  return (
    <div className={className} role="row" style={style} ref={ref}>
      {columns}
    </div>
  );
};
